window.addEventListener('DOMContentLoaded', (event) => {
	const element = document.getElementById('glossaryTerm');

	if (document.body.contains(element)) {
		const list = JSON.parse(element.dataset.autocomplete);

		// initiate the autocomplete function, and pass along the array as possible autocomplete values:
		autocomplete(element, list);
	}

	function autocomplete(input, arr) {
		// the autocomplete function takes two arguments, the text field element and an array of possible autocompleted values:
		let currentFocus;

		// execute a function when someone writes in the text field:
		input.addEventListener('input', function (e) {
			let list,
				listItem,
				val = this.value;

			// close any already open lists of autocompleted values
			closeAllLists();

			let hasVal = !val ? true : false;

			this.classList.toggle('has-val', !hasVal);

			if (!val) {
				return false;
			}
			currentFocus = -1;

			// create a DIV element that will contain the items (values):
			list = document.createElement('DIV');
			list.setAttribute('id', this.id + 'autocomplete-list');
			list.setAttribute('class', 'autocomplete-items');

			// append the DIV element as a child of the autocomplete container:
			this.parentNode.appendChild(list);

			// for each item in the array...
			for (let i = 0; i < arr.length; i++) {
				// check if the item starts with the same letters as the text field value:
				if (
					arr[i].substr(0, val.length).toUpperCase() ==
					val.toUpperCase()
				) {
					// create a DIV element for each matching element:
					listItem = document.createElement('DIV');

					// make the matching letters bold:
					listItem.innerHTML =
						'<strong>' + arr[i].substr(0, val.length) + '</strong>';
					listItem.innerHTML += arr[i].substr(val.length);

					// insert a input field that will hold the current array item's value:
					listItem.innerHTML +=
						"<input type='hidden' value='" + arr[i] + "'>";

					// execute a function when someone clicks on the item value (DIV element):
					listItem.addEventListener('click', function (e) {
						// insert the value for the autocomplete text field:
						input.value =
							this.getElementsByTagName('input')[0].value;

						// update uri with value
						window.location.hash = encodeURI(
							input.value.replace(/\s+/g, '-').toLowerCase()
						);

						// close the list of autocompleted values, (or any other open lists of autocompleted values:
						closeAllLists();

						// close mobile menu
						document
							.querySelector('.search-bar')
							.classList.remove('open');
						input.classList.remove('has-val');
					});

					list.appendChild(listItem);
				}
			}
		});

		// execute a function presses a key on the keyboard:
		input.addEventListener('keyup', function (event) {
			let list = document.getElementById(this.id + 'autocomplete-list');
			if (list) list = list.getElementsByTagName('div');

			if (event.keyCode == 40) {
				// If the arrow DOWN key is pressed, increase the currentFocus letiable:
				currentFocus++;

				// and and make the current item more visible:
				addActive(list);
			} else if (event.keyCode == 38) {
				//up

				// If the arrow UP key is pressed, decrease the currentFocus letiable:
				currentFocus--;

				// and and make the current item more visible:
				addActive(list);
			} else if (event.keyCode == 13) {
				// If the ENTER key is pressed, prevent the form from being submitted,
				event.preventDefault();

				if (currentFocus > -1) {
					// and simulate a click on the "active" item:
					if (list) list[currentFocus].click();
				}
			}
		});

		function addActive(item) {
			// a function to classify an item as "active":
			if (!item) return false;

			// start by removing the "active" class on all items:
			removeActive(item);

			if (currentFocus >= item.length) currentFocus = 0;
			if (currentFocus < 0) currentFocus = item.length - 1;

			// add class "autocomplete-active":
			item[currentFocus].classList.add('autocomplete-active');
		}

		function removeActive(item) {
			// a function to remove the "active" class from all autocomplete items:
			for (let i = 0; i < item.length; i++) {
				item[i].classList.remove('autocomplete-active');
			}
		}

		function closeAllLists(self) {
			// close all autocomplete lists in the document, except the one passed as an argument:
			let element = document.getElementsByClassName('autocomplete-items');

			for (let i = 0; i < element.length; i++) {
				if (self != element[i] && self != input) {
					element[i].parentNode.removeChild(element[i]);
				}
			}
		}

		// execute a function when someone clicks in the document:
		document.addEventListener('click', function (event) {
			closeAllLists(event.target);
		});
	}
});
